import { render, staticRenderFns } from "./CarouselMenu.vue?vue&type=template&id=0ed0d132&scoped=true&"
import script from "./CarouselMenu.vue?vue&type=script&lang=js&"
export * from "./CarouselMenu.vue?vue&type=script&lang=js&"
import style0 from "./CarouselMenu.vue?vue&type=style&index=0&id=0ed0d132&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed0d132",
  null
  
)

export default component.exports